import { render, staticRenderFns } from "./ManageReportGeneratedList.vue?vue&type=template&id=20ccb787&"
import script from "./ManageReportGeneratedList.vue?vue&type=script&lang=js&"
export * from "./ManageReportGeneratedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports